<template lang="pug">
  .root
    the-heading(:caption="'Запросы'" :breadcrumbs="breadcrumbs")
    .container
      .main_block
        .globalCaptionStyles.localCaption Запросы
        .filter_block
          Keypress(:key-code="13" event="keyup" @pressed="pressEnter")
          .fields
            .item
              label ID
              .field_container
                WebiomedInput(v-model="filter.id__icontains" :value="filter.id__icontains || null")
            .item
              label Совершён c
              .field_container
                WebiomedDatepicker(v-model="filter.created_date__gt" :value="filter.created_date__gt || null")
            .item
              label Совершён по
              .field_container
                WebiomedDatepicker(v-model="filter.created_date__lt" :value="filter.created_date__lt || null")
            .item#longField
              label Название МО
              .field_container
                WebiomedSearchField(
                  v-model="filter.hospital_name"
                  :value="filter.hospital_name"
                  :search_by="'hospital_name'"
                  :show="'hospital_name'"
                  :address="'webiomedmpi/requests/hospital-names/'"
                  :fieldAdd="'?hospital_name__icontains='"
                  :placeholder="'Введите название МО'"
                  :icons="'clinic-medical'",
                  :namespase="'Requests'"
                  )
            .item
              label PatientID
              .field_container
                WebiomedInput(v-model="filter.patient_id" :value="filter.patient_id || null")
            .item#longField
              label Сценарий использования
              .field_container
                WebiomedSelect(:options="useCase" v-model="filter.use_case" :value="filter.use_case || null")
            .item
              label Версия
              .field_container
                WebiomedSelect(:options="apiVersion" v-model="filter.api_version" :value="filter.api_version || null")
          .buttons
            button.find(@click="find") Найти
            button.clear(@click="clear") Очистить фильтры
            //- v-icon(name="notes-medical sx")
            div(style="display: inline-block; margin-left: 5px") Количество записей:
            span(style="font-weight: bold") {{' ' +count}}
        page-grid(:cols="cols" ref="grid" :response="data" :nextState="nextState" :count="count")
</template>
<script>
import TheHeading from '@/components/parts/TheHeading'
import WebiomedInput from '@/components/fields/WebiomedInput'
import WebiomedDatepicker from '@/components/fields/WebiomedDatepicker'
import WebiomedSearchField from '@/components/fields/WebiomedSearchField'
import WebiomedSelect from '@/components/fields/WebiomedSelect'
import PageGrid from '../parts/PageGrid'
import pageGridMixin from '@/mixins/pageGridMixin'
import breadcrumbs from '@/data/breadcrumbs/Requests'
import cols from '@/data/cols/requests'
import Icon from 'vue-awesome/components/Icon'
import useCase from '@/data/options/usecase'
import apiVersion from '@/data/options/apiversion'

export default {
  components: {
    PageGrid,
    TheHeading,
    WebiomedInput,
    WebiomedDatepicker,
    WebiomedSearchField,
    WebiomedSelect,
    'v-icon': Icon,
    breadcrumbs,
    Keypress: () => import('vue-keypress')
  },

  mixins: [pageGridMixin],
  data () {
    return {
      address: 'webiomedmpi/requests/?fields=id,created_date,hospital_name,patient_id,use_case,created_by_region_name,attention_level,api_version,response_time,his_request_build_time',
      api: 'dhra/api/v2/',
      breadcrumbs,
      cols,
      nextState: 'RequestSummary',
      iconFiels: {
        key: 'file',
        iconName: 'file',
        class: 'blue'
      },
      useCase,
      apiVersion
    }
  },
  created () {
    if (this.$route.query) {
      for (let key in this.$route.query) {
        if (key !== 'modified_by') {
          this.filter[key] = this.$route.query[key]
        }
      }
    }
    localStorage.removeItem('sParams')
  },
  methods: {
    setData (response) {
      this.data = response.map(item => {
        let useCaseName = ''
        if (item.use_case === 'scenario_unknown') useCaseName = 'Сценарий использования неизвестен или не указан'
        if (item.use_case === 'manual_estimation') useCaseName = 'Запрос оценки данных пациента врачом в ручном режиме'
        if (item.use_case === 'analysis_refer') useCaseName = 'Автоматический анализ данных пациента при обращении пациента в МО'
        if (item.use_case === 'analysis_closed_case') useCaseName = 'Автоматический анализ данных пациента при завершении обследования/лечения в МО (закрытие случая, ИБ и т.д.)'
        if (item.use_case === 'analysis_treatment') useCaseName = 'Автоматический анализ данных во время нахождения пациента в медицинской организации'
        if (item.use_case === 'group_estimation') useCaseName = 'Автоматическая групповая оценка пациентов'
        if (item.use_case === 'retrospective_analysis') useCaseName = 'Ретроспективный анализ данных'
        if (item.use_case === 'patient_reassessment') useCaseName = 'Автоматическая переоценка пациента системой «Webiomed»'
        if (item.use_case === 'automatic_analysis_pre_recorded_patients') useCaseName = 'Автоматический анализ предварительно записанных в МО пациентов'

        let respTime = (item.response_time ? item.response_time : 0) + (item.his_request_build_time ? item.his_request_build_time : 0)

        return {
          id: item.id,
          created_date: this.$moment(item.created_date).format('DD.MM.YYYY'),
          time: this.$moment(item.created_date).format('HH:mm'),
          hospital: item.hospital_name,
          patient_id: item.patient_id,
          use_case: useCaseName,
          region: item.created_by_region_name,
          cc_risk: item.result ? item.result[0].nosology.risk_group.text : false,
          attention_level: item.attention_level ? item.attention_level === 'red' ? 'Высокий' : item.attention_level === 'yellow' ? 'Умеренный' : 'Низкий' : '—',
          api_version: item.api_version,
          response_time: respTime.toFixed(2)
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
@import "@/css/pageGridStyles.sass"
#longField
  grid-column: 1 / span 2

#longlongField
  grid-column: 1 / span 3

@media screen and (max-width: 1460px)
  .fields
    grid-template-columns: 1fr
  #longField
    grid-column: 1
  #longlongField
    grid-column: 1
</style>
<style lang="sass">
.Requests
  font-size: 15px
  height: 32px
</style>
